import * as React from 'react';
import { ArticleHeading1, Responsive } from '@cian/ui-kit';
import { ProjectsOnMapRedesigned as ProjectsOnMapComponent } from '../../components/ProjectsOnMap';
import { Map } from '../Map/MapRedesigned';
import { trackShowProjectsMap } from './tracking';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';

export function ProjectsOnMap() {
  return (
    <Responsive desktop>
      <ActionAfterViewed callback={trackShowProjectsMap}>
        <ProjectsOnMapComponent title={<ArticleHeading1>Объекты на карте</ArticleHeading1>} map={<Map />} />
      </ActionAfterViewed>
    </Responsive>
  );
}
